var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.currentComponent === 'AdminListNotices')?_c('AdminListNotices'):_vm._e(),(_vm.currentComponent === 'AdminFacets')?_c('AdminFacets'):_vm._e(),(_vm.currentComponent === 'AdminRenderingNotice')?_c('AdminRenderingNotice'):_vm._e(),(_vm.currentComponent === 'FrontListNotices')?_c('FrontListNotices'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }